import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBracketsCurly = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M8.25 1.75H8A3.25 3.25 0 0 0 4.75 5c0 3 0 3.75-2 5 2 1.25 2 2 2 5A3.25 3.25 0 0 0 8 18.25h.25m3.5-16.5H12A3.25 3.25 0 0 1 15.25 5c0 3 0 3.75 2 5-2 1.25-2 2-2 5A3.25 3.25 0 0 1 12 18.25h-.25"
	})]
});
const ForwardRef = forwardRef(SvgBracketsCurly);
export { ForwardRef as ReactComponent };
